<template>
	<div>
		<component
			:is="states[currentState].icon"
			class="cloud-sync-status-icon size-4"
			:class="states[currentState].iconClass"
		/>
	</div>
</template>

<script setup lang="ts">
import CloudUpAnimatedIcon from '@/components/icons/CloudUpAnimatedIcon.vue'
import SlashCloudIcon from '@/components/icons/SlashCloudIcon.vue'
import type { Component } from 'vue'

defineProps({ currentState: { type: String, required: true } })

const states: Record<string, { icon: Component | null; iconClass?: string }> = {
	NoSync: { icon: null },
	OfflinePending: { icon: SlashCloudIcon, iconClass: 'text-slate-300' },
	Syncing: { icon: CloudUpAnimatedIcon, iconClass: 'text-primary-200' },
}
</script>

<style scoped></style>
